(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["D7-draggable-infinite-slider"] && !window.DesignMode) return;
  try {
    
  // Initialize Swiper
  var swiper = new Swiper(".d7-draggable-my-swiper", {
    slidesPerView: 1,
    spaceBetween: 30,
    loop: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    on: {
      slideChange: function () {
        updateActiveTab(this.realIndex);
        console.log("real index: ",this.realIndex);
      },
    },
  });

    function updateActiveTab(index) {
      document.querySelectorAll('.profile-tab').forEach(tab => {tab.classList.remove('active')})
      document.querySelectorAll('.profile-tab')[index].classList.add('active')
    }

     document.querySelectorAll('.profile-tab').forEach((tab, index) => {
    tab.addEventListener('click', function(e) {
      swiper.slideToLoop(index);
    });
  }); 
  

  document.querySelector('.profile-tab').classList.add('active');
  function updateActiveTab(index) {
  console.log('umais')
    const profileTabs = document.querySelectorAll('.profile-tab');
    const container = document.querySelector('.trusted-blocks-d6'); // The scrollable container

    if (!profileTabs.length || !container) return; // Ensure elements exist

    // Remove active class from all tabs
    profileTabs.forEach(tab => tab.classList.remove('active'));

    // Add active class to the new active tab
    const activeTab = profileTabs[index];
    activeTab.classList.add('active');

    // Center the active tab in the container
    const containerWidth = container.offsetWidth;
    const tabWidth = activeTab.offsetWidth;
    const tabOffsetLeft = activeTab.offsetLeft;
    
    const scrollPosition = tabOffsetLeft - (containerWidth / 2) + (tabWidth / 2);

    container.scrollTo({
        left: scrollPosition,
        behavior: 'smooth'
    });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["d7-multicolumn"] && !window.DesignMode) return;
  try {
    
  function handleChange(mutationsList, observer) {
    for (let mutation of mutationsList) {
      if (mutation.type === 'characterData' || mutation.type === 'childList') {
        yourFunction(mutation.target.textContent);
      }
    }
  }

  const targetElement = document.querySelector('#d7-custom-slider-number');

  const observer = new MutationObserver(handleChange);

  const config = {
    characterData: true,
    childList: true,
    subtree: true
  };

  observer.observe(targetElement, config);

  let slideNumber, dots;

  function yourFunction(e) {
    slideNumber = Number(e);
    dots= document.getElementsByClassName('d7-custom-multicolumn-dots');
    for (let dot of dots) {
      dot.classList.remove("active")
    }
    dots[slideNumber - 1].classList.add("active")
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
